(() => {
  if (document.body.dataset.mgTemplate !== 'collection' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const main = document.querySelector('main');
  if (!main || !('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  let sequence = 0;
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      entry.target.style.setProperty('--mg-arrival-delay', `${(sequence++ % 4) * 55}ms`);
      entry.target.classList.add('mg-collection-arrive');
    }
  }, { threshold: 0.08 });
  const observe = () => {
    main.querySelectorAll('h1, .section-content-wrapper > .text-block p, .mg-collection-nav a, product-card .product-media__image, product-card .mg-native-title, product-card product-price').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      observer.observe(element);
    });
  };
  observe();
  new MutationObserver(observe).observe(main, { childList: true, subtree: true });
})();
